import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactSortable } from 'react-sortablejs';

import Modal from '../../../../../../components/Modal';
import {
  backendErrorNotification,
  frontendNotification,
} from '../../../../../../components/Notification';
import ReactSortableItem from '../../../../../../components/ReactSortableItem';
import HttpStatus from '../../../../../../enums/httpStatus';
import * as reqBanner from '../../../../../../services/requests/banners';
import { Smartbanner } from '../../../../../../types/apiResponseTypes';

type Props = {
  showModal: boolean;
  closeModal: () => void;
  banners: Smartbanner[];
  reqGetAllBanners: () => void;
};

type BannerOrderItem = {
  id: number;
  bannerId: number;
  description: string;
  sort_number: number;
};

const ReorderBannersModal = ({ closeModal, showModal, banners, reqGetAllBanners }: Props) => {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);

  // Create a sortable list from the banners
  const [orderedBanners, setOrderedBanners] = useState<BannerOrderItem[]>(
    banners
      .sort((a, b) => {
        const aSort = a.sort_number || 0;
        const bSort = b.sort_number || 0;
        return aSort - bSort;
      })
      .map((banner, index) => ({
        id: index, // Para o ReactSortable
        bannerId: banner.id, // ID real do banner
        description: banner.description,
        sort_number: banner.sort_number || 0,
      }))
  );

  const handleSaveOrder = async () => {
    setIsLoading(true);
    try {
      const bannerIds = orderedBanners.map((banner) => banner.bannerId);

      const response = await reqBanner.reorderBanners(bannerIds);

      if (response.status === HttpStatus.OK) {
        frontendNotification({
          message: t('success'),
          type: 'success',
        });

        reqGetAllBanners();
        closeModal();
      } else {
        throw response;
      }
    } catch (erro) {
      backendErrorNotification(erro as any);
    } finally {
      setIsLoading(false);
    }
  };

  const handleOnChangeSortableArea = (newOrder: BannerOrderItem[]) => {
    setOrderedBanners(newOrder);
  };

  return (
    <Modal
      title={t('displayOrder')}
      showModal={showModal}
      closeModal={closeModal}
      action={handleSaveOrder}
      isLoading={isLoading}
      actionNameBtn={t('save')}
    >
      <div style={{ padding: '1rem 0' }}>
        <p style={{ margin: '1rem' }}>
          {t('dragItemsToReorder')}
        </p>

        <ReactSortable
          list={orderedBanners}
          setList={handleOnChangeSortableArea}
          style={{ margin: '0.7rem' }}
        >
          {orderedBanners.map((banner, index) => (
            <ReactSortableItem key={banner.bannerId}>
              <div
                style={{
                  borderRadius: '4px',
                  cursor: 'move',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <span>{index + 1}&nbsp;-&nbsp;</span>
                <span>{banner.description}</span>
              </div>
            </ReactSortableItem>
          ))}
        </ReactSortable>
      </div>
    </Modal>
  );
};

export default ReorderBannersModal;
